import * as React from 'react';
import AddItemWideButton, { GenerateRequestObject } from './AddItemWideButton';
import { ConfigureSectionDto } from './AccordionContainer';
import { StyledInnerAccordion } from './ConfigurePage.styles';
import ListItemComponent, { ConfigurableItemDto } from './ListItem';
import { AccordionDetails, AccordionSummary, List, Typography } from '@mui/material';
import ExpandIcon from './Utils/ExpandIcon';
import { post } from '../lib/api';
import { useState } from 'react';
import ConditionedSnackbar from './ConditionedSnackbar';

interface InnerSectionComponentProps {
    isExpanded: boolean;
    parentPanel: string;
    dto: ConfigureSectionDto;
    handleChange: (isExpanded: boolean, panel: string) => void;
}

const InnerSectionComponent = (props: InnerSectionComponentProps) => {
    const { name, configurableItems } = props.dto;
    const { isExpanded, parentPanel, handleChange } = props;
    const [isErrored, setErrored] = useState(false);
    const [items, setItems] = useState<ConfigurableItemDto[]>(
        configurableItems.sort((a, b) => Number(a.value) - Number(b.value))
    );

    //Snackbar
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarArgument, setSnackbarArgument] = useState<string>('');
    const snackBarMessage = (functionName: string) => {
        switch (functionName) {
            case 'add-item':
                return `Item for "${name}" ${isErrored ? 'was not' : ''} succesfully added.`;
            default:
                return '';
        }
    };
    //endregion

    const onNewItemAdd = async (object: GenerateRequestObject | null) => {
        try {
            setErrored(false);
            const addedItem = await post(`appconfigs/create`, object);
            const newList = [...items, addedItem.data];
            setItems(newList);
            setSnackbarArgument('add-item');
            setShowSnackbar(true);
        } catch (error) {
            setErrored(true);
            setSnackbarArgument('add-item');
            setShowSnackbar(true);
        }
    };

    return (
        <>
            <StyledInnerAccordion
                expanded={isExpanded}
                elevation={0}
                disableGutters={true}
                onChange={(_: unknown, isExpanded: boolean) =>
                    handleChange(isExpanded, `${parentPanel}-${name}`)
                }>
                <AccordionSummary expandIcon={<ExpandIcon isExpanded={isExpanded} />}>
                    <Typography variant="h4">{name}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ p: '0' }}>
                    <List>
                        {items &&
                            items.map((item: ConfigurableItemDto, index) => (
                                <ListItemComponent key={index} dto={item} isInner={true} />
                            ))}
                        <AddItemWideButton sectionName={name} onNewItemAdd={onNewItemAdd} />
                    </List>
                </AccordionDetails>
            </StyledInnerAccordion>
            <ConditionedSnackbar
                open={showSnackbar}
                handleClose={() => setShowSnackbar(false)}
                severity={!isErrored ? 'success' : 'error'}
                message={snackBarMessage(snackbarArgument)}
            />
        </>
    );
};

export default InnerSectionComponent;
